/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const FishSymbol = [["path", { d: "M2 16s9-15 20-4C11 23 2 8 2 8" }]];

export { FishSymbol as default };
//# sourceMappingURL=fish-symbol.js.map
